module.exports = __webpack_public_path__ + "img/1.24c60d5a.webp";